var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58301 2.57143C4.58301 1.75181 5.1274 0.75 6.16634 0.75H9.83301C10.8719 0.75 11.4163 1.75181 11.4163 2.57143V4.5C11.4163 4.91421 11.0806 5.25 10.6663 5.25C10.2521 5.25 9.91634 4.91421 9.91634 4.5V2.57143C9.91634 2.42867 9.87057 2.32611 9.83025 2.27427C9.82102 2.2624 9.81367 2.25475 9.80843 2.25H6.19092C6.18568 2.25475 6.17833 2.2624 6.1691 2.27427C6.12878 2.32611 6.08301 2.42867 6.08301 2.57143V4.5C6.08301 4.91421 5.74722 5.25 5.33301 5.25C4.91879 5.25 4.58301 4.91421 4.58301 4.5V2.57143ZM6.20028 2.24308C6.2003 2.24321 6.1993 2.24392 6.19721 2.24484C6.19921 2.24342 6.20026 2.24296 6.20028 2.24308ZM9.79907 2.24308C9.79909 2.24296 9.80013 2.24342 9.80214 2.24484C9.80005 2.24392 9.79905 2.24321 9.79907 2.24308Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44886 3.5855C3.86186 3.55373 4.22241 3.86277 4.25418 4.27577L4.89122 12.5575L4.14365 12.615L4.89122 12.5575C4.92128 12.9482 5.2471 13.25 5.63901 13.25H10.3609C10.7528 13.25 11.0786 12.9482 11.1087 12.5575L11.8565 12.615L11.1087 12.5575L11.7457 4.27577C11.7775 3.86277 12.1381 3.55373 12.5511 3.5855C12.964 3.61727 13.2731 3.97782 13.2413 4.39081L12.6043 12.6725C12.5141 13.8447 11.5366 14.7499 10.3609 14.75H5.63899C4.46329 14.7499 3.4858 13.8447 3.39564 12.6725L4.14343 12.615L3.39564 12.6725L2.75859 4.39081C2.72682 3.97782 3.03587 3.61727 3.44886 3.5855Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0498 4.3335C1.0498 3.91928 1.38559 3.5835 1.7998 3.5835H13.7998C14.214 3.5835 14.5498 3.91928 14.5498 4.3335C14.5498 4.74771 14.214 5.0835 13.7998 5.0835H1.7998C1.38559 5.0835 1.0498 4.74771 1.0498 4.3335Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.29175C8.27614 7.29175 8.5 7.51561 8.5 7.79175V10.4584C8.5 10.7346 8.27614 10.9584 8 10.9584C7.72386 10.9584 7.5 10.7346 7.5 10.4584V7.79175C7.5 7.51561 7.72386 7.29175 8 7.29175Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.0d237442d576d1ddd21aed061e3d1bd6.svg";
export { ForwardRef as ReactComponent };